import AssessmentScreen from "app/screens/residents/show/AssessmentScreen";

export default function ResidentAssessmentPage() {
  return <AssessmentScreen />;
}
